import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { ColorPicker, Divider, ScrollableTabs, Text } from '@reveni-io/reveni-ui'

import TabLabel from '../TabLabel/TabLabel'
import { selectorSubTabs, subTabToColorGroup } from './constants'
import * as Styles from './styles'

const Selectors = ({ colors = {}, changeColor, disabled, activeSubTab, onSubTabChange, subTabErrors = {} }) => {
  const { t } = useTranslation()

  const subTabs = [
    {
      label: <TabLabel label={t('Método / solicitud')} hasError={subTabErrors[selectorSubTabs.methodRequest]} />,
      value: selectorSubTabs.methodRequest,
    },
    {
      label: <TabLabel label={t('Variante')} hasError={subTabErrors[selectorSubTabs.variant]} />,
      value: selectorSubTabs.variant,
    },
  ]

  const activeColorGroup = subTabToColorGroup[activeSubTab]
  const activeGroup = colors[activeColorGroup]
  const types = activeGroup ? Object.entries(activeGroup.types) : []

  return (
    <Styles.GroupContainer>
      <Styles.SubTabsSection>
        <ScrollableTabs tabs={subTabs} value={activeSubTab} onChange={onSubTabChange} />
      </Styles.SubTabsSection>
      {types.map(([typeKey, type], index) => (
        <Fragment key={typeKey}>
          <Styles.TypeSection>
            {index > 0 && (
              <Styles.SectionDivider>
                <Divider />
              </Styles.SectionDivider>
            )}
            <Styles.TypeContent>
              {type.label && <Text type="titleS">{t(type.label)}</Text>}
              <Styles.ColorsContainer>
                {Object.entries(type.colors).map(([colorKey, { label, color, orientation }]) => (
                  <ColorPicker
                    orientation={orientation}
                    onChange={value => changeColor({ value, group: activeColorGroup, type: typeKey, color: colorKey })}
                    label={t(label)}
                    defaultColor={color}
                    key={colorKey}
                    disabled={disabled}
                  />
                ))}
              </Styles.ColorsContainer>
            </Styles.TypeContent>
          </Styles.TypeSection>
        </Fragment>
      ))}
    </Styles.GroupContainer>
  )
}

export default Selectors
